module.exports = __webpack_public_path__ + "img/12.8dad6204.svg";